/* @flow */

export default class RegisterSellerCompanyResponse {
  companyId: number;
  companyPersonId: number;
  companyAlreadyExist: boolean;
}
